import { connect } from 'react-redux';

import { meActions } from 'src/common/state/me/me-actions';
import {
  selectIsLoggedIn,
  selectIsMeFetching,
  selectTerms2026AcceptError,
  selectTerms2026AcceptPending,
} from 'src/common/state/me/me-selectors';
import type { RootState } from 'src/redux';

import {
  TERMS_2026_BANNER_START_DATE,
  Terms2026BannerComponent,
} from './terms-2026-banner-component';

export const isTerms2026BannerEligibleUser = (state: RootState) => {
  if (state.me.terms_accepted_2026 !== null) {
    return false;
  }

  const { date_added } = state.me;

  if (date_added === undefined) {
    return false;
  }

  if (date_added === null) {
    return true;
  }

  return date_added * 1000 < TERMS_2026_BANNER_START_DATE.getTime();
};

export const selectIsTerms2026BannerShowing = (state: RootState) =>
  selectIsLoggedIn(state) &&
  !selectIsMeFetching(state) &&
  isTerms2026BannerEligibleUser(state);

const mapStateToProps = (state: RootState) => ({
  isShowing: selectIsTerms2026BannerShowing(state),
  isAcceptPending: Boolean(selectTerms2026AcceptPending(state)),
  acceptError: selectTerms2026AcceptError(state) ?? null,
  userKey: state.me.id ?? state.me.user_name,
});

const mapDispatchToProps = {
  onAccept: (marketing_opt_in: boolean) =>
    meActions.terms2026Banner.accepted({ marketing_opt_in }),
};

export const Terms2026Banner = connect(
  mapStateToProps,
  mapDispatchToProps
)(Terms2026BannerComponent);
